import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';

@Component({
  selector: 'cigna-lob-selector',
  templateUrl: './lob-selector.component.html',
  styleUrls: ['./lob-selector.component.scss'],
})
export class LobSelectorComponent implements OnInit {
  @Input() prompt = 'Select the line of business';
  @Input() defaultValue = '';
  @Output() commercialSelected: EventEmitter<unknown> = new EventEmitter();
  @Output() medicareSelected: EventEmitter<unknown> = new EventEmitter();

  selectTypeForm: FormGroup;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.selectTypeForm = this.formBuilder.group({
      patientType: [
        ['commercial', 'medicare'].includes(this.defaultValue)
          ? this.defaultValue
          : '',
      ],
    });
  }

  get patientType(): FormControl {
    return this.selectTypeForm.controls.patientType as FormControl;
  }

  onCommercialLobSelected() {
    this.commercialSelected.emit();
  }

  onMedicareLobSelected() {
    this.medicareSelected.emit();
  }
}
